export const IDENTITY_PROVIDERS = {
  BCEID_BUSINESS: 'bceidbusiness',
  IDIR: 'idir'
}
